import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const services = [
    { name: 'Pressure Washing', path: '/services/pressure-washing' },
    { name: 'Window Cleaning', path: '/services/window-washing' },
    { name: 'Carpet Cleaning', path: '/services/carpet-cleaning' },
    { name: 'Gutter Cleaning', path: '/services/gutter-cleaning' },
    { name: 'Soft Wash', path: '/services/soft-wash' },
    { name: 'Solar Panel Cleaning', path: '/services/solar-panel-cleaning' },
    { name: 'Dumpster Pad Cleaning', path: '/services/dumpster-pad-cleaning' },
  ];

  const locations = [
    { name: 'Camarillo', path: '/camarillo' },
    { name: 'Fillmore', path: '/fillmore' },
    { name: 'Moorpark', path: '/moorpark' },
    { name: 'Oxnard', path: '/oxnard' },
    { name: 'Port Hueneme', path: '/port-hueneme' },
    { name: 'Santa Paula', path: '/santa-paula' },
    { name: 'Simi Valley', path: '/simi-valley' },
    { name: 'Thousand Oaks', path: '/thousand-oaks' },
    { name: 'Ventura', path: '/ventura' },
  ];
  
  return (
    <footer className="bg-gradient-to-b from-gray-800 to-gray-900 text-white">
      <div className="container mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="inline-block bg-white rounded-lg px-4 py-2 mb-4">
              <img
                src="/logo/ventura-power-washing-horizontal.png"
                alt="Ventura Power Washing"
                width="900"
                height="330"
                className="h-16 w-auto"
              />
            </div>
            
            <p className="text-gray-400 mb-4">
              Professional power washing, window cleaning, and carpet care services in Ventura County.
            </p>
            
            <div className="flex items-start text-gray-400">
              <MapPin className="h-5 w-5 mr-2 mt-0.5 flex-shrink-0" />
              <div className="flex flex-wrap gap-x-1 gap-y-0.5">
                <span>Serving </span>
                {locations.map((location, index) => (
                  <span key={location.path}>
                    <Link 
                      to={location.path}
                      className="hover:text-white transition-colors duration-300"
                    >
                      {location.name}
                    </Link>
                    {index < locations.length - 1 && ', '}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4 border-b border-gray-700 pb-2">Services</h3>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service.path}>
                  <Link 
                    to={service.path} 
                    className="text-gray-400 hover:text-white transition-colors duration-300"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 border-b border-gray-700 pb-2">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="/#services" className="text-gray-400 hover:text-white transition-colors duration-300">All Services</a>
              </li>
              <li>
                <a href="/#benefits" className="text-gray-400 hover:text-white transition-colors duration-300">Benefits</a>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors duration-300">About Us</Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-400 hover:text-white transition-colors duration-300">FAQ</Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-400 hover:text-white transition-colors duration-300">Blog</Link>
              </li>
              <li>
                <a href="/#contact" className="text-gray-400 hover:text-white transition-colors duration-300">Contact</a>
              </li>
            </ul>
          </div>
          
          {/* Contact & Social */}
          <div>
            <h3 className="text-lg font-bold mb-4 border-b border-gray-700 pb-2">Contact & Follow Us</h3>
            <p className="text-gray-400 mb-2">
              <a href="tel:+18054647166" className="hover:text-white transition-colors duration-300">
                (805) 464-7166
              </a>
            </p>
            
            <div className="flex items-center space-x-4 mb-6">
              <a href="https://www.facebook.com/venturapowerwashing" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors duration-300" aria-label="Ventura Power Washing on Facebook">
                <Facebook className="h-6 w-6" />
              </a>
              <a href="https://www.instagram.com/venturacleaningco" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors duration-300" aria-label="Ventura Power Washing on Instagram">
                <Instagram className="h-6 w-6" />
              </a>
              <a href="https://www.yelp.com/biz/ventura-power-washing-thousand-oaks" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors duration-300 text-sm font-semibold" aria-label="Ventura Power Washing on Yelp">
                Yelp
              </a>
            </div>

            <Link 
              to="/free-estimate" 
              className="inline-block bg-ventura-green text-white px-6 py-2 rounded-full hover:bg-green-600 transition-colors duration-300"
            >
              Get Free Estimate
            </Link>
          </div>
        </div>
        
        <div className="mt-12 pt-6 border-t border-gray-800 text-center text-gray-500">
          <p>© {currentYear} Ventura Power Washing. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
